export default __webpack_public_path__ + "static/media/logo.fadbf2ca.png";